import { atom } from 'jotai';

import type { AdminFeeMessages } from './AdminFee.messages';

export const adminFeeMessagesAtom = atom<AdminFeeMessages | null>(null);
